import { useState } from 'react'
import { Button, Divider, Typography } from '@mui/material'
import ButtonSwitch from './buttonSwitch'
import { useSelector } from 'react-redux';

export default function GerenciarPrivilegios({ cancelEditPrivilegios, user }) {
    const [permissions, setPermissions] = useState(user?.permissions)
    const userLogado = useSelector(state => state.account.user);

    const Header = ({ header }) => { return (<Typography m={1}> <b>{header}</b> </Typography>) }

    return (
        <div>
            <Typography variant='h4'>
                Gerenciar Privilégios
            </Typography>

            {(userLogado?.funcao === "Director Geral" || userLogado?.funcao === "CNP") &&
                <>
                    <Header header={'Privilégios Master'} />

                    <ButtonSwitch
                        adminId={user._id}
                        permission={'allPermissions'}
                        permissions={permissions}
                        setPermission={setPermissions}
                        title={'Conceder todos Privilégios'}
                        descricao={''}
                    />
                    <ButtonSwitch
                        adminId={user._id}
                        permission={'concederPermissions'}
                        permissions={permissions}
                        setPermission={setPermissions}
                        title={'Conceder Privilégios'}
                        descricao={''}
                    />
                    <Divider />
                </>
            }

            <ButtonSwitch
                adminId={user._id}
                permission={'Dashboard'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Dashboard'}
                descricao={''}
            />

            {/* <ButtonSwitch
                adminId={user._id}
                permission={'Menu'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Menu'}
                descricao={''}
            /> */}

            <ButtonSwitch
                adminId={user._id}
                permission={'Relatório'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Relatório'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'AutorizaçãoEmitidas'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Autorização Emitidas'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'Chat'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Chat'}
                descricao={''}
            />


            <Divider />
            <Header header={'Secções'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'secçãoLicenciamento'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Secção de Licenciamento'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'secçãoCertificadoProdutoControlo'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Secção de Certificados Para Produtos Controlados'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'secçãoImportação'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Secção de Importação'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'secçãoDesalfandegamento'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Secção de Desalfandegamento'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'secçãoExpediente'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Secção de Expediente'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'secçãoFarmacovigilancia'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Secção de Farmacovigilância'}
                descricao={''}
            />


            <ButtonSwitch
                adminId={user._id}
                permission={'secçãoControleQualidade'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Secção de Controle de Qualidade'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'secçãoMedicamentos'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Secção de Medicamentos'}
                descricao={''}
            />


            <Divider />
            <Header header={'Estabelecimentos'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'VerEstabelecimentosLicenciados'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Ver Estabelecimentos Licenciados'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'CategoriasEstabelecimentos'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Categorias de Estabelecimentos'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'CadastrarEstabelecimentos'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Cadastrar Estabelecimentos'}
                descricao={''}
            />


            <Divider />
            <Header header={'Empresas'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'VerEmpresas'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Ver Empresas'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'CadastrarEmpresas'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Cadastrar Empresas'}
                descricao={''}
            />


            <Divider />
            <Header header={'Representantes'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'VerRepresentantes'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Ver Representantes'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'CadastrarRepresentantes'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Cadastrar Representantes'}
                descricao={''}
            />


            <Divider />
            <Header header={'Directores Técnicos'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'VerDirectoresTécnicos'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Ver Directores Técnicos'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'CadastrarDirectorTécnico'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Cadastrar Director Técnico'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'CategoriasdeDirectorTécnico'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Categorias de Director Técnico'}
                descricao={''}
            />


            <Divider />
            <Header header={'Licenciamento de Estabelecimento'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'licenciamentoEstabelecimentoTecnico'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Licenciamento de Estabelecimento na Áre Técnica'}
                descricao={''}
            />
            <ButtonSwitch
                adminId={user._id}
                permission={'licenciamentoEstabelecimentoChefeSeccao'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Licenciamento de Estabelecimento em Chefe de Secção'}
                descricao={''}
            />
            <ButtonSwitch
                adminId={user._id}
                permission={'licenciamentoEstabelecimentoChefeDepartamento'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Licenciamento de Estabelecimento em Chefe de Departamento'}
                descricao={''}
            />
            <ButtonSwitch
                adminId={user._id}
                permission={'licenciamentoEstabelecimentoInspeccaoAgendada'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Licenciamento de Estabelecimento em Inspecção Agendada'}
                descricao={''}
            />
            <ButtonSwitch
                adminId={user._id}
                permission={'licenciamentoEstabelecimentoInspeccaoRealizada'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Licenciamento de Estabelecimento em Inspecção Realizada'}
                descricao={''}
            />
            <ButtonSwitch
                adminId={user._id}
                permission={'licenciamentoEstabelecimentoDeferimento'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Licenciamento de Estabelecimento em Aprovar Estabelecimento'}
                descricao={''}
            />


            <Divider />
            <Header header={'Importação Normal'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoImportacaoAnalise'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Importação em Análise '}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoImportacaoAnalisado'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Importação Analisado por Técnicos '}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoImportacaoDeferimento'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Importação em Deferimento '}
                descricao={''}
            />

            <Divider />
            <Header header={'Importação de Produto Controlado'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoImportacaoControladosAnalise'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Importação de Controlados em Análise '}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoImportacaoControladosAnalisado'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Importação de Controlados Analisado por Técnicos '}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoImportacaoControladosDeferimento'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Importação de Controlados em Deferimento '}
                descricao={''}
            />
            
            <ButtonSwitch
                adminId={user._id}
                permission={'approveProdutoListaControlados'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Aprovar itens da lista de Importação de Controlados  '}
                descricao={''}
            />


            <Divider />
            <Header header={'Desalfandegamento'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoDesalfandegamentoAnalise'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Desalfandegamento em Análise '}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoDesalfandegamentoAnalisado'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Desalfandegamento Analisado por Técnicos '}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'solicitacaoDesalfandegamentoDeferimento'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Solicitação de Desalfandegamento em Deferimento '}
                descricao={''}
            />

            <Divider />
            <Header header={'Controle de Qualidade'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'controleQualidadeAnalise'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Controle de Qualidade em Análise '}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'controleQualidadeAtribuirAnalistaRevisor'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Controle de Qualidade Atribuir Analista e Revisor'}
                descricao={''}
            />
            <ButtonSwitch
                adminId={user._id}
                permission={'controleQualidadeRelatorioAnalitico'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Controle de Qualidade Atribuir Emitir Relatório Análitico'}
                descricao={''}
            />
            <ButtonSwitch
                adminId={user._id}
                permission={'controleQualidadeEmissaoCertificado'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Controle de Qualidade Emissão do Certificado'}
                descricao={''}
            />


            <Divider />
            <Header header={'Agenda'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'CriarAgenda'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Criar Agenda'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'VerAgendasDisponiveis'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Ver Agendas Disponiveis'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'VerAgendasMarcadas'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Ver Agendas Marcadas'}
                descricao={''}
            />


            <Divider />
            <Header header={'Medicamentos'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'TabelaGeral'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Tabela Geral'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'TabelaCategorias'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Tabela de Categorias'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'TabelaSolicitações'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Tabela de Solicitações'}
                descricao={''}
            />


            <Divider />
            <Header header={'Gerenciador do site'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'GestãoBanner'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Gestão do Banner'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'GestãoNoticias'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Gestão de Noticias'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'GestãoDocumentos'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Gestão de Documentos'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'GestãoInformaçõesSite'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Gestão de Informações do Site'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'GestãoArgitosCiêntifico'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Gestão de Argitos Ciêntifico'}
                descricao={''}
            />


            <Divider />
            <Header header={'Gerencidor de Administradores'} />
            <ButtonSwitch
                adminId={user._id}
                permission={'CadastrarAdministrador'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Cadastrar Administrador'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'VerAdministradores'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Ver lista de Administradores'}
                descricao={''}
            />
            <ButtonSwitch
                adminId={user._id}
                permission={'acessarPerfilsUser'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Ver perfil individual de Administradores'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'ConfigurarDepartamento'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Configurar Departamento'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'HistoricosActividades'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Historicos de Actividades'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'HistoricosLogin'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Historicos de Login'}
                descricao={''}
            />


            <ButtonSwitch
                adminId={user._id}
                permission={'CentralImpressão'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Central de impressão'}
                descricao={''}
            />

            <ButtonSwitch
                adminId={user._id}
                permission={'Access'}
                permissions={permissions}
                setPermission={setPermissions}
                title={'Access'}
                descricao={''}
            />

            <Button onClick={() => cancelEditPrivilegios(false)} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Fechar</Button>
        </div>
    )
}
